import { Col, List, Modal, Row, Typography } from 'antd'
import React, { useEffect, useState } from 'react'
import { Flex, Button, SearchBox, MultiButton } from 'components/hulam_platform';
import { callApi, snackBar } from 'utils';
import Scrollbars from 'react-custom-scrollbars';
import { ChevronDownIcon, ChevronUpIcon, DeleteIcon } from 'components/icon';
import "components/EmployeePicker/employeePicker.scss"
import useDebounce from 'hooks/useDebounce';

export default function EmployeePicker(props) {
  const [searchData, setSearchData] = useState("");
  const [empList, setEmpList] = useState([]); 
  const [mbCNo, setMbCNo] = useState(props&&props.data&&props.data.mbCNo);
  const [selectEmpList, setSelectEmpList] = useState([]);
  const [toggleExpand, setToggleExpand] = useState(true);
  const colorList = ["#936FFA", "#FF91B8", "#FF6D6D", "#FB9270", "#FFDA46", "#C7C13A", "#74C84C", "#76D7C5", "#6CB0FF", "#5F8AFA"];
  const debouncedSearchText = useDebounce(searchData);

 

  useEffect(() => {
    setMbCNo(mbCNo);
  }, [mbCNo])


  const getSelectEmpList = async () => {
    let sessionStorage = window.sessionStorage;
    let opId = sessionStorage.getItem("userId");

    const postData = {
      opId: opId,mbCNo:mbCNo
    };

    const response = await callApi('api/platform/employeeManagerList', postData);
 
    if (response.result) {
      setSelectEmpList(response.data.map((item, index) => ({ ...item, key: `${item.name}_${index}` })));
    }

  }

  useEffect(() => {
     


    // 생략...
   

    getEmpList();
     // eslint-disable-next-line react-hooks/exhaustive-deps
    getSelectEmpList();
     // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
     
    // 생략...
    
    getEmpList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [debouncedSearchText])

  /**@function createAvatar()
   * 1. 사원 아바타 생성
   */
  const createAvatar = (empInfo = null, size = 32) => {
    if (empInfo === null) {
      return (
        <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M0 16C0 4 4 0 16 0C28 0 32 4 32 16C32 28 28 32 16 32C4 32 0 28 0 16Z" fill="#999999" />
          <path d="M14.4018 10.7412C13.325 10.7412 12.4521 11.6333 12.4521 12.7337C12.4521 13.8341 13.325 14.7261 14.4018 14.7261C15.4787 14.7261 16.3516 13.8341 16.3516 12.7337C16.3516 11.6333 15.4787 10.7412 14.4018 10.7412ZM11.2374 12.7337C11.2374 10.9478 12.6542 9.5 14.4018 9.5C16.1495 9.5 17.5662 10.9478 17.5662 12.7337C17.5662 14.5196 16.1495 15.9673 14.4018 15.9673C12.6542 15.9673 11.2374 14.5196 11.2374 12.7337ZM17.6745 10.0777C17.8004 9.75998 18.1544 9.60668 18.4653 9.73529C19.6239 10.2145 20.4429 11.3756 20.4429 12.7337C20.4429 14.0917 19.6239 15.2528 18.4653 15.7321C18.1544 15.8607 17.8004 15.7074 17.6745 15.3897C17.5487 15.0719 17.6987 14.7101 18.0096 14.5815C18.7252 14.2855 19.2283 13.5689 19.2283 12.7337C19.2283 11.8985 18.7252 11.1818 18.0096 10.8858C17.6987 10.7572 17.5487 10.3954 17.6745 10.0777ZM13.4212 17.3392H15.3824C15.9598 17.3392 16.4238 17.3392 16.8012 17.3655C17.1887 17.3925 17.5289 17.4493 17.8502 17.5853C18.6256 17.9135 19.2416 18.5431 19.5628 19.3354C19.6959 19.6637 19.7515 20.0114 19.7779 20.4074C19.8037 20.793 19.8037 21.2673 19.8037 21.8572V21.8794C19.8037 22.2221 19.5318 22.5 19.1963 22.5C18.8609 22.5 18.589 22.2221 18.589 21.8794C18.589 21.2621 18.5887 20.8303 18.5661 20.4919C18.5439 20.1591 18.5022 19.9623 18.4406 19.8104C18.2427 19.3222 17.8632 18.9343 17.3854 18.7321C17.2368 18.6692 17.0442 18.6265 16.7185 18.6038C16.3874 18.5807 15.9648 18.5804 15.3607 18.5804H13.4429C12.8389 18.5804 12.4163 18.5807 12.0851 18.6038C11.7595 18.6265 11.5669 18.6692 11.4182 18.7321C10.9405 18.9343 10.5609 19.3222 10.363 19.8104C10.3015 19.9623 10.2598 20.1591 10.2375 20.4919C10.2149 20.8303 10.2146 21.2621 10.2146 21.8794C10.2146 22.2221 9.94271 22.5 9.60731 22.5C9.2719 22.5 9 22.2221 9 21.8794L9 21.8572C9 21.2673 8.99999 20.793 9.02574 20.4074C9.05218 20.0114 9.10779 19.6637 9.24087 19.3354C9.56204 18.5431 10.1781 17.9135 10.9534 17.5853C11.2747 17.4493 11.6149 17.3925 12.0025 17.3655C12.3798 17.3392 12.8439 17.3392 13.4212 17.3392ZM19.8867 17.8874C19.9704 17.5555 20.3014 17.3557 20.6263 17.4411C21.991 17.8 23 19.0653 23 20.5729V21.8794C23 22.2221 22.7281 22.5 22.3927 22.5C22.0573 22.5 21.7854 22.2221 21.7854 21.8794V20.5729C21.7854 19.6453 21.1646 18.8644 20.3235 18.6431C19.9987 18.5577 19.8031 18.2194 19.8867 17.8874Z" fill="white" />
        </svg>
      )
    } else {
      const empName = (/^[a-zA-Z]/.test(empInfo.name)) ? empInfo.name[0].toUpperCase() : empInfo.name.slice(-2);

      return (
        <svg width={size} height="32" viewBox={`0 0 32 32`} fill="none" xmlns="http://www.w3.org/2000/svg" style={{ flex: "0 0 auto" }}>
          <path d="M0 16C0 4 4 0 16 0C28 0 32 4 32 16C32 28 28 32 16 32C4 32 0 28 0 16Z" fill={colorList[empInfo.opeNo % 10]} />
          <text fontSize="12px" x="16" y="20" textAnchor="middle" fill="white">{empName}</text>
        </svg>
      )
    }
  }

  const getEmpList = async () => {
    let sessionStorage = window.sessionStorage;
    let opId = sessionStorage.getItem("userId");

    const postData = {
      opId: opId,
      searchText: searchData
    };

    const response = await callApi('api/platform/employeeList', postData);
 
    if (response.result) {
      setEmpList(response.data.map((item, index) => ({ ...item, key: `${item.name}_${index}` })));
    }

  }

  const onSave = async () =>{
    let sessionStorage = window.sessionStorage;
    let opId = sessionStorage.getItem("userId");

    if(mbCNo){
      const postData = {
        opId: opId,
        selectEmpList: selectEmpList, 
        mbCNo:mbCNo
      };
  
      await callApi('api/platform/updateEmployeeManager', postData);
    }else{
      snackBar(<>휴램 계정이 연결된 상태에서 담당 직원을 설정할 수 있어요!</> )
    }
    
    return props.reload();
  }

  return (
    <Modal
      className="multi_select_emp_box"
      centered
      width={759}
      open={props.modalOpen}
      closable={false}
      styles={{
        body: {
          padding: 0, height: 603, maxHeight: 'none', overflow: 'hidden'
        }
      }}
      footer={
        <MultiButton>
          <Button
            type="secondary"
            onClick={() => {
              setSelectEmpList([]);
              props.modalClose();
            }}
            size="sm"

          >닫기</Button>
          <Button
            type='primary'
            onClick={() => {
              onSave();
              //props.selection(selectEmpList);
              setSelectEmpList([]);
              props.modalClose();
            }}
            size="sm"
            width={120}
          >선택완료</Button>
        </MultiButton>
      }
    >
      <Row style={{ height: "100%" }}>
        <Col span={12} style={{ position: "relative", borderRight: "1px solid var(--gray-200-divider)" }}>
          <Typography.Title
            level={5}
            style={{
              height: "66px",
              padding: "21px 0 21px 20px",
              background: "#f3f4f8",
              borderBottom: "1px solid var(--gray-200-divider)",
              borderTopLeftRadius: "10px"
            }}
          >
            사원 목록
          </Typography.Title>
          <Row style={{ padding: "30px 20px 60px 20px" }}>
            <Col span={24} style={{ display: "flex" }}>
              <SearchBox 
                style={{
                  width: "100%"
                }}
                value={searchData}
                placeholder="이름, 담당, 이메일"
                onChange={(e) => setSearchData(e.target.value)}
                onClick={() => getEmpList()}
              />
            </Col>
          </Row>
          <Scrollbars style={{ height: 420, borderTop: "1px solid var(--gray-200-divider)" }} autoHide>
            <List
              itemLayout="horizontal"
              dataSource={empList}
              renderItem={(item, idx) => {
                return (
                  <>
                    {
                      idx === 0 && (
                        <List.Item
                          className={`emp_list_item ${selectEmpList.length === empList.length ? "active" : ""}`}
                          style={{ padding: '13px 36px 13px 20px' }}
                          onClick={(e) => {
                            if (!e.target.closest("button")) {
                              setSelectEmpList(current => {
                                let newData = [];
                                if (current.length !== empList.length) {
                                  newData = [...empList];
                                }
                                return newData;
                              })
                            }
                          }}
                        >
                          <Button
                            type="text"
                            size="sm"
                            style={{ width: 16, height: 16, padding: 0, marginRight: 10 }}
                            onClick={() => setToggleExpand(!toggleExpand)}
                          >
                            {
                              toggleExpand ? <ChevronDownIcon size={16} /> : <ChevronUpIcon size={16} />
                            }

                          </Button>
                          <List.Item.Meta
                            avatar={createAvatar()}
                            title={<>전체 사원 <span style={{ paddingLeft: "6px", fontWeight: "400", fontSize: "12px", color: "Var(--gray-700-text)" }}>({empList.length})</span></>}
                          />
                        </List.Item>
                      )
                    }
                    {
                      toggleExpand && (
                        <List.Item
                          className={selectEmpList.find(selectEmp => selectEmp.opeNo === item.opeNo) ? "active" : ""}
                          style={{ padding: '13px 36px 13px 46px' }}
                          onClick={() => {
                            setSelectEmpList(current => {
                              let newData = [...current];

                              if (current.find(selectEmp => selectEmp.opeNo === item.opeNo)) {
                                newData = newData.filter(selectEmp => selectEmp.opeNo !== item.opeNo)
                              } else {
                                newData = [...newData, item]
                              };

                              return newData
                            })
                          }}
                        >
                          <List.Item.Meta
                            avatar={createAvatar(item)}
                            title={<>{item.name} <span style={{ paddingLeft: "6px", fontWeight: "400", fontSize: "12px", color: "Var(--gray-700-text)" }}>({item.role})</span></>}
                            description={`${item.employeeEmail}`}
                          />
                        </List.Item>
                      )
                    }
                  </>
                )
              }}
            />
          </Scrollbars>
        </Col>
        <Col span={12}>
          <Flex
            justifyContent='space-between'
            alignItems='center'
            style={{
              height: "66px",
              background: "#f3f4f8",
              borderTopRightRadius: "10px",
              justifyContent: "space-between",
            }}
          >
            <Typography.Title level={5} style={{ padding: "21px 0 21px 20px", marginBottom: 0 }}>
              사원 선택됨<span style={{ paddingLeft: "10px", fontSize: "14px", fontWeight: 400, color: "var(--gray-400-placeholder)" }}>{selectEmpList.length ? selectEmpList.length : ''}</span>
            </Typography.Title>
            {
              selectEmpList.length > 0 && (
                <Button type='text' onClick={() => setSelectEmpList(() => [])} style={{ color: "#999", fontSize: 14, fontWeight: 400, lineHeight: "20px" }}>전체 삭제</Button>
              )
            }
          </Flex>
          {
            selectEmpList.length > 0 ? (
              <Scrollbars style={{ height: 537 }} autoHide>
                <List
                  itemLayout="horizontal"
                  dataSource={selectEmpList}
                  renderItem={(item, idx) => {
                    return (
                      <List.Item
                        className={"selected_emp_item"}
                        style={{ padding: '0 31px 0 20px', height: 65 }}
                        actions={[<Button type='text' onClick={() => setSelectEmpList(current => current.filter(emp => emp.opeNo !== item.opeNo))}><DeleteIcon /></Button>]}
                      >
                        <List.Item.Meta
                          avatar={createAvatar(item)}
                          title={<>{item.name} <span style={{ paddingLeft: "6px", fontWeight: "400", fontSize: "12px", color: "Var(--gray-700-text)" }}>({item.role})</span></>}
                          description={`${item.employeeEmail}`}
                        />
                      </List.Item>
                    )
                  }}
                />
              </Scrollbars>
            ) : (
              <Flex direction='column' justifyContent='center' style={{ height: 537 }} columnGap={10}>
                <svg width="56" height="56" viewBox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <g clipPath="url(#clip0_1373_182634)">
                    <path fillRule="evenodd" clipRule="evenodd" d="M30.199 0.0850816C29.4734 0.0287116 28.7401 0 28 0C27.2599 0 26.5266 0.0287117 25.801 0.0850819L25.9365 1.82982C26.6171 1.77695 27.3052 1.75 28 1.75C28.6948 1.75 29.3829 1.77695 30.0635 1.82982L30.199 0.0850816ZM21.4607 0.76773L21.8679 2.4697C20.5193 2.79237 19.2111 3.21917 17.9523 3.74117L17.2819 2.12465C18.6253 1.56759 20.0214 1.11209 21.4607 0.76773ZM13.3683 4.12247L14.2841 5.61373C13.1094 6.33509 11.9956 7.14646 10.9524 8.0383L9.81525 6.70812C10.9276 5.75718 12.1154 4.8919 13.3683 4.12247ZM6.70811 9.81525L8.0383 10.9524C7.14645 11.9956 6.33509 13.1094 5.61373 14.2841L4.12247 13.3683C4.89189 12.1154 5.75718 10.9276 6.70811 9.81525ZM2.12465 17.2819L3.74117 17.9523C3.21917 19.2111 2.79236 20.5193 2.46969 21.8679L0.767729 21.4607C1.11209 20.0214 1.56759 18.6253 2.12465 17.2819ZM0.0850816 25.801L1.82982 25.9365C1.77695 26.6171 1.75 27.3052 1.75 28C1.75 28.6948 1.77695 29.3829 1.82982 30.0635L0.0850819 30.199C0.0287117 29.4734 0 28.7401 0 28C0 27.2599 0.0287116 26.5266 0.0850816 25.801ZM0.76773 34.5393L2.4697 34.1321C2.79237 35.4807 3.21917 36.7889 3.74117 38.0477L2.12465 38.7181C1.56759 37.3747 1.11209 35.9786 0.76773 34.5393ZM4.12247 42.6317L5.61373 41.7159C6.33509 42.8906 7.14646 44.0044 8.0383 45.0476L6.70812 46.1848C5.75718 45.0724 4.8919 43.8846 4.12247 42.6317ZM9.81525 49.2919L10.9524 47.9617C11.9956 48.8535 13.1094 49.6649 14.2841 50.3863L13.3683 51.8775C12.1154 51.1081 10.9276 50.2428 9.81525 49.2919ZM17.2819 53.8753L17.9523 52.2588C19.2111 52.7808 20.5193 53.2076 21.8679 53.5303L21.4607 55.2323C20.0214 54.8879 18.6253 54.4324 17.2819 53.8753ZM25.801 55.9149L25.9365 54.1702C26.6171 54.223 27.3052 54.25 28 54.25C28.6948 54.25 29.3829 54.223 30.0635 54.1702L30.199 55.9149C29.4734 55.9713 28.7401 56 28 56C27.2599 56 26.5266 55.9713 25.801 55.9149ZM34.5393 55.2323L34.1321 53.5303C35.4807 53.2076 36.7889 52.7808 38.0477 52.2588L38.7181 53.8753C37.3747 54.4324 35.9786 54.8879 34.5393 55.2323ZM42.6317 51.8775L41.7159 50.3863C42.8906 49.6649 44.0044 48.8535 45.0476 47.9617L46.1848 49.2919C45.0724 50.2428 43.8846 51.1081 42.6317 51.8775ZM49.2919 46.1847L47.9617 45.0476C48.8535 44.0044 49.6649 42.8906 50.3863 41.7159L51.8775 42.6317C51.1081 43.8846 50.2428 45.0724 49.2919 46.1847ZM53.8753 38.7181L52.2588 38.0477C52.7808 36.7889 53.2076 35.4807 53.5303 34.1321L55.2323 34.5393C54.8879 35.9786 54.4324 37.3747 53.8753 38.7181ZM55.9149 30.199L54.1702 30.0635C54.223 29.3829 54.25 28.6948 54.25 28C54.25 27.3052 54.223 26.6171 54.1702 25.9365L55.9149 25.801C55.9713 26.5266 56 27.2599 56 28C56 28.7401 55.9713 29.4734 55.9149 30.199ZM55.2323 21.4607L53.5303 21.8679C53.2076 20.5193 52.7808 19.2111 52.2588 17.9523L53.8753 17.2819C54.4324 18.6253 54.8879 20.0214 55.2323 21.4607ZM51.8775 13.3683L50.3863 14.2841C49.6649 13.1094 48.8535 11.9956 47.9617 10.9524L49.2919 9.81525C50.2428 10.9276 51.1081 12.1154 51.8775 13.3683ZM46.1847 6.70811L45.0476 8.0383C44.0044 7.14645 42.8906 6.33509 41.7159 5.61373L42.6317 4.12247C43.8846 4.89189 45.0724 5.75718 46.1847 6.70811ZM38.7181 2.12465L38.0477 3.74117C36.7889 3.21917 35.4807 2.79236 34.1321 2.46969L34.5393 0.767729C35.9786 1.11209 37.3747 1.56759 38.7181 2.12465Z" fill="#E2E5EA" />
                    <path fillRule="evenodd" clipRule="evenodd" d="M28.3889 18.0835C26.4398 18.0835 24.6701 19.8036 24.6701 22.1668C24.6701 24.5301 26.4398 26.2502 28.3889 26.2502C30.338 26.2502 32.1076 24.5301 32.1076 22.1668C32.1076 19.8036 30.338 18.0835 28.3889 18.0835ZM21.1701 22.1668C21.1701 18.0868 24.2974 14.5835 28.3889 14.5835C32.4804 14.5835 35.6076 18.0868 35.6076 22.1668C35.6076 26.2469 32.4804 29.7502 28.3889 29.7502C24.2974 29.7502 21.1701 26.2469 21.1701 22.1668ZM25.082 30.7871C25.1704 30.7871 25.2599 30.7872 25.3507 30.7872H31.4271C31.5179 30.7872 31.6074 30.7871 31.6958 30.7871C33.1265 30.7859 34.2404 30.785 35.1999 31.0955C37.3445 31.7894 38.9645 33.5566 39.5851 35.7385C39.8626 36.7146 39.862 37.8517 39.8612 39.4053C39.8612 39.4912 39.8611 39.5784 39.8611 39.6668C39.8611 40.6333 39.0776 41.4168 38.1111 41.4168C37.1446 41.4168 36.3611 40.6333 36.3611 39.6668C36.3611 37.7376 36.3442 37.1379 36.2185 36.6959C35.8965 35.5634 35.0849 34.7369 34.1224 34.4255C33.761 34.3086 33.2578 34.2872 31.4271 34.2872H25.3507C23.5199 34.2872 23.0167 34.3086 22.6554 34.4255C21.6929 34.7369 20.8813 35.5634 20.5592 36.6959C20.4335 37.1379 20.4167 37.7376 20.4167 39.6668C20.4167 40.6333 19.6332 41.4168 18.6667 41.4168C17.7002 41.4168 16.9167 40.6333 16.9167 39.6668C16.9167 39.5784 16.9166 39.4912 16.9166 39.4053C16.9158 37.8517 16.9151 36.7146 17.1927 35.7385C17.8132 33.5566 19.4333 31.7894 21.5779 31.0955C22.5374 30.785 23.6513 30.7859 25.082 30.7871Z" fill="#E2E5EA" />
                  </g>
                  <defs>
                    <clipPath id="clip0_1373_182634">
                      <rect width="56" height="56" fill="white" />
                    </clipPath>
                  </defs>
                </svg>
                <Typography.Text type="desc">사원 목록에서 사원 또는 부서를 선택해주세요.</Typography.Text>
              </Flex>
            )
          }

        </Col>
      </Row >

    </Modal >
  )
}
